<div>
    <span [ngClass]="(isViewApo ? 'label': 'date-label')">Fecha</span>
    <p-calendar 
        [(ngModel)]="selectedDate" 
        (ngModelChange)="onDateChange($event)" 
        [iconDisplay]="'input'" 
        dateFormat="dd/mm/yy" 
        dataType="date"
        [showIcon]="true"
        [locale]="es"
        
        />

</div>
